function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import App from 'modules/App';
import Cgm from 'svg/cgm-points.svg';
import Bgm from 'svg/joined-points.svg';
import OneDirectional from 'svg/one-directional.svg';
import TwoDirectional from 'svg/two-directional.svg';
import messages from '../../../messages';
import styles from '../ExternalDataSource.pcss';
const getIcon = (capability)=>{
    switch(capability.type){
        case 'Bgm':
            return Bgm;
        case 'Cgm':
            return Cgm;
        default:
            return null;
    }
};
const getTagMessage = (capability)=>{
    const { defaultMode } = capability;
    if (defaultMode === 'Read') return messages.tags.get;
    if (defaultMode === 'Write') return messages.tags.send;
    return messages.tags.getAndSend;
};
const TagDirection = ({ capability })=>{
    const { defaultMode } = capability;
    if (defaultMode === 'Read') return /*#__PURE__*/ _jsx(OneDirectional, {
        className: "rotate180"
    });
    if (defaultMode === 'Write') return /*#__PURE__*/ _jsx(OneDirectional, {});
    return /*#__PURE__*/ _jsx(TwoDirectional, {});
};
const Capability = ({ capability })=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const name = get(localizationResources, [
        capability.nameKey,
        'value'
    ], capability.type);
    const tagMessage = getTagMessage(capability);
    const Icon = getIcon(capability);
    return /*#__PURE__*/ _jsxs("tr", {
        children: [
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row no-gutters align-items-center",
                    children: [
                        Icon && /*#__PURE__*/ _jsx("div", {
                            className: "col-auto",
                            children: /*#__PURE__*/ _jsx(Icon, {
                                className: styles.dataSource__capability__icon
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto",
                            children: name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "section__table__autoFitCol",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "tag tag--info",
                    children: [
                        /*#__PURE__*/ _jsx(TagDirection, {
                            capability: capability
                        }),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, tagMessage))
                    ]
                })
            })
        ]
    });
};
export default Capability;
